export const constantRoutes = [
  {
    path: '/',
    name: 'root',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'system' */ '@/views/system/Login')
  },
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: 'system' */ '@/views/system/Error')
  }
]
